import { action } from 'satcheljs';

/**
 * Action which sets the timerId for the current toast to be used for clearing the timeout
 * @param timerId the new value for timerId
 */
export default action('setTimerId', function setTimerId(timerId: NodeJS.Timer | null) {
    return { timerId };
});
